module.exports = __webpack_public_path__ + "static/img/hubs.aaf4d2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIQ/hubs.png
// module id = 67Wi
// module chunks = 0